/**
 * Auth labels
 * Dynamic mapping from JSON based on current language
 * Uses getLanguage() to determine which locale to use
 */

import svAuth from '../locales/sv/auth.json';
import enAuth from '../locales/en/auth.json';
import { getLanguage, type Language } from '@/utils/languageUtils';

/**
 * Helper function to get the correct locale based on language
 */
const getAuthLocale = (lang?: Language) => {
  const currentLang = lang || getLanguage();
  return currentLang === 'en' ? enAuth : svAuth;
};

/**
 * Auth labels - dynamically uses current language
 */
export const authLabels = (lang?: Language): Record<string, any> => {
  const locale = getAuthLocale(lang);
  return locale || {};
};


